var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
function SvgRaceIqInfo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "none",
    stroke: "#1b1c38",
    strokeWidth: 2
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M11 7.53c-.44 0-.8-.12-1.07-.38-.27-.25-.41-.56-.41-.93s.14-.68.41-.93.62-.38 1.07-.38.78.12 1.06.35c.28.24.41.54.41.91 0 .39-.14.71-.41.97-.27.26-.62.38-1.06.38zm-1.17 9.2V9.66h2.34v7.07H9.83z",
    fill: "#1b1c38"
  })));
}
export default SvgRaceIqInfo;